/* eslint-disable babel/new-cap */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Watch } from 'vue-property-decorator';
import { Getter, State, Action } from 'vuex-class';
import html2canvas from 'html2canvas';
let FinalPage = class FinalPage extends Vue {
    constructor() {
        super(...arguments);
        this.isPC = window.isPC;
    }
    handleCurrentChange() {
        this.current === this.totalCount && this.totalCount > 1 && this.generatorCanvas();
    }
    handleShowInfoChange() {
        this.generatorCanvas();
    }
    get generatorPcStyle() {
        if (this.isPC) {
            return {
                width: this.h5WidthStyle,
                height: this.h5HeightStyle,
            };
        }
        else {
            return {
                width: '100vw',
                height: '100vh',
            };
        }
    }
    get typeImg() {
        let img = '';
        if (this.page8 && this.page8.alias_flag) {
            img = require(`../assets/page8/final-type-${this.page8.alias_flag}.png`);
        }
        return img;
    }
    getWindowW() {
        return window.innerWidth || window.document.documentElement.clientWidth || window.screen.width;
    }
    getWindowH() {
        return window.innerHeight || document.documentElement.clientHeight || window.screen.height;
    }
    generatorCanvas() {
        if (this.isPC) {
            return;
        }
        if (Object.keys(this.page8).length === 0) {
            return;
        }
        if ((this.showInfo && this.showInfoImg) || (!this.showInfo && this.hideInfoImg)) {
            return;
        }
        this.$nextTick(() => {
            const $dom = document.querySelector('#generator-page');
            const $canvas = document.createElement('canvas');
            const $ctx = $canvas.getContext('2d');
            $canvas.width = this.getWindowW() * 2;
            $canvas.height = this.getWindowH() * 2;
            $canvas.style.width = `${this.getWindowW() * 2}px`;
            $canvas.style.height = `${this.getWindowH() * 2}px`;
            $ctx.scale(2, 2);
            html2canvas($dom, {
                canvas: $canvas,
                useCORS: true,
            }).then(canvas => {
                // const img = canvas.toDataURL('image/png')
                canvas.toBlob(blob => {
                    const formData = new FormData();
                    // formData.append('file',api.dataURLtoBlob(data))
                    formData.append('file', blob);
                    formData.append('bucket', 'active');
                    this.GENERATOR_BFSIMG({
                        img: formData,
                        type: this.showInfo,
                    });
                });
            });
        });
    }
    mounted() {
        if (!HTMLCanvasElement.prototype.toBlob) {
            Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
                value: function (callback, type, quality) {
                    const binStr = atob(this.toDataURL(type, quality).split(',')[1]);
                    const len = binStr.length;
                    const arr = new Uint8Array(len);
                    for (let i = 0; i < len; i++) {
                        arr[i] = binStr.charCodeAt(i);
                    }
                    callback(new Blob([arr], { type: type || 'image/png' }));
                },
            });
        }
        this.generatorCanvas();
    }
};
__decorate([
    Getter
], FinalPage.prototype, "page8", void 0);
__decorate([
    Getter
], FinalPage.prototype, "hideTop", void 0);
__decorate([
    Getter
], FinalPage.prototype, "page5", void 0);
__decorate([
    Getter
], FinalPage.prototype, "h5WidthStyle", void 0);
__decorate([
    Getter
], FinalPage.prototype, "h5HeightStyle", void 0);
__decorate([
    State
], FinalPage.prototype, "qrcodeImg", void 0);
__decorate([
    State
], FinalPage.prototype, "totalCount", void 0);
__decorate([
    State
], FinalPage.prototype, "current", void 0);
__decorate([
    State
], FinalPage.prototype, "showInfo", void 0);
__decorate([
    State
], FinalPage.prototype, "userInfo", void 0);
__decorate([
    State
], FinalPage.prototype, "showInfoImg", void 0);
__decorate([
    State
], FinalPage.prototype, "hideInfoImg", void 0);
__decorate([
    Action
], FinalPage.prototype, "GENERATOR_BFSIMG", void 0);
__decorate([
    Watch('current')
], FinalPage.prototype, "handleCurrentChange", null);
__decorate([
    Watch('showInfo')
], FinalPage.prototype, "handleShowInfoChange", null);
FinalPage = __decorate([
    Component
], FinalPage);
export default FinalPage;
